import type { ShiftActionsModalProps } from "@/components/modals/ShiftActionsModal.types.tsx";
import ShiftActions, { buildShiftActionsController } from "@/components/sections/ShiftActions.tsx";
import React, { useEffect } from "react";
import Modal from "./Modal";







/**
 * Main component
 * @param param0
 * @returns 
 */
const ShiftActionsModal: React.FC<ShiftActionsModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        confirmDisabled = false,
        shiftId: shiftId,
        schedule
    }) => {
    
    const ctrl = buildShiftActionsController(shiftId,schedule);
    //const [editData , setEditData] = useState({...{},...solverConfigs});


    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(()=>{
        if(open && shiftId){
            ctrl.initializeShiftEditDataFromShiftId(shiftId);
        }
    },[open]);

    const handleConfirm = () => {
        onConfirm(ctrl.editData);
        onClose();
    };

    const blockConfirm = confirmDisabled;


    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            size="md"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={blockConfirm}
                        className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${blockConfirm ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                    >
                        {confirmLabel}
                    </button>
                </>
            }
        >
            <ShiftActions
                controller={ctrl}>

            </ShiftActions>

        </Modal>
    );
};

export default ShiftActionsModal;
